import i, { useMemo as D, useEffect as C } from "react";
import { TextField as g } from "@amenitiz/design-system";
import { Dropdown as O } from "./index195.mjs";
import { useAutocompleteService as R } from "./index144.mjs";
import { APIProvider as L } from "@vis.gl/react-google-maps";
import { useAtomValue as f, useSetAtom as h } from "jotai";
import { normaliseAddress as F, AddressComponentType as o } from "./index243.mjs";
import { getConfigPropertyAtomCreator as I, ConfigProperty as T } from "./index13.mjs";
import { FieldState as _ } from "./index196.mjs";
import { setClientDetailsAtom as y, selectedClientDetailsAtom as N } from "./index55.mjs";
import { ADDRESS_FIELD as l, CITY_FIELD as d, POSTAL_CODE_FIELD as m, REGION_FIELD as p, COUNTRY_FIELD as E } from "./index56.mjs";
const k = (a) => {
  try {
    return JSON.parse(a);
  } catch {
    return {};
  }
}, v = ({ setCountry: a }) => {
  const n = R(
    document.getElementById(l)
  ), s = h(y), r = f(N), u = k(
    f(
      D(() => I(T.REGIONS), [])
    )
  );
  return C(() => {
    const e = n == null ? void 0 : n.addListener("place_changed", () => {
      const c = n.getPlace();
      if (c != null && c.address_components) {
        const t = F(c.address_components), A = t[o.STREET_NUMBER], b = t[o.STREET_ADDRESS] || t[o.ROUTE] ? (t[o.STREET_ADDRESS] || t[o.ROUTE]) + (A ? ` ${A}` : "") : "";
        s({
          [l]: b,
          [d]: t[o.LOCALITY],
          [m]: t[o.POSTAL_CODE],
          [p]: t[o.REGION]
        });
        const S = t[o.COUNTRY];
        a(S);
      }
    });
    return () => {
      e && e.remove();
    };
  }, [n, a, s]), /* @__PURE__ */ i.createElement(i.Fragment, null, /* @__PURE__ */ i.createElement(
    g,
    {
      autocomplete: "street-address",
      label: I18n.t("booking_engine.information.address"),
      disabled: !1,
      required: !0,
      id: l,
      name: l,
      state: _.DEFAULT,
      onChange: (e) => {
        s({
          [l]: e
        });
      },
      placeholder: I18n.t("booking_engine.information.address_placeholder"),
      value: r[l]
    }
  ), /* @__PURE__ */ i.createElement(
    g,
    {
      autocomplete: "address-level2",
      label: I18n.t("booking_engine.information.city"),
      disabled: !1,
      required: !0,
      id: d,
      name: d,
      state: _.DEFAULT,
      onChange: (e) => {
        s({
          [d]: e
        });
      },
      placeholder: I18n.t("booking_engine.information.city_placeholder"),
      value: r[d]
    }
  ), r[E] && u[r[E]] ? /* @__PURE__ */ i.createElement(
    O,
    {
      id: p,
      name: p,
      "data-testid": "region-field",
      label: I18n.t("booking_engine.information.region"),
      placeholder: `- ${I18n.t(
        "booking_engine.information.select_region"
      )} -`,
      selectedOption: r.country,
      onChange: (e) => {
        s({
          [p]: e
        });
      },
      options: u[r[E]].map(
        (e) => ({
          label: I18n.t(
            `regions.${r[E]}.${e}`
          ),
          value: e
        })
      )
    }
  ) : null, /* @__PURE__ */ i.createElement(
    g,
    {
      autocomplete: "postal-code",
      label: I18n.t("booking_engine.information.postal_code"),
      disabled: !1,
      required: !0,
      id: m,
      name: m,
      state: _.DEFAULT,
      onChange: (e) => {
        s({
          [m]: e
        });
      },
      placeholder: I18n.t(
        "booking_engine.information.postal_code_placeholder"
      ),
      value: r[m]
    }
  ));
}, w = ({ setCountry: a }) => {
  const n = f(
    D(
      () => I(T.GOOGLE_MAPS_ENV_KEY),
      []
    )
  );
  return /* @__PURE__ */ i.createElement(L, { apiKey: n || "", libraries: ["places"] }, /* @__PURE__ */ i.createElement(v, { setCountry: a }));
};
export {
  w as Address
};
